declare let bootstrap: any;

/**
 * 
 * @param messageType info,success,warn,error
 * @param message 
 */
export function showToast(messageType: string, message: string) {
    const dom = document.createElement('div');
    dom.classList.add('toast');
    let className = '';
    messageType = messageType.toLowerCase();
    switch (messageType) {
        case 'success':
            className = 't-success';
            break;
        case 'warn':
            className = 't-warning';
            break;
        case 'error':
            className = 't-error';
            break;
        default:
            className='t-info';
            break;
    }
    dom.classList.add(className);
    dom.setAttribute('role', 'alert');
    dom.setAttribute('aria-live', 'assertive');
    dom.setAttribute('aria-atomic', 'true');
    dom.innerHTML = `<div class="d-flex">
                    <div class="toast-body">
                    </div>
                    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>`;

    dom.querySelector('.toast-body').innerHTML = message;

    document.body.append(dom);

    const toastInstance = new bootstrap.Toast(dom,
        {
            autohide: messageType === 'info' || messageType === 'success',
            delay: 2000
        });
    toastInstance.show();
}